export enum VerticalEnum {
    City = 9,
    Park = 10,
    ['K12 School'] = 11,
    Museum = 12,
    University = 13,
    ['Historical Center'] = 14,
    County = 15,
    ['Veterans Organization'] = 16,
    ['Religious Organization'] = 139,
    ['Funeral Home'] = 140,
    ['Sports Facility'] = 177,
    ['Community Non-Profit'] = 178,
}
export enum AppFormCategoryTypeEnum
{
    ['Template Form'] = 171,
    ['Sample Data'] = 170,
    Both = 172,
}
export enum  TimeZoneEnum
{
    EST = 173,
    CST = 174,
    MST = 175,
    PST = 176
}